import { getMessaging, getToken } from "firebase/messaging";
import app from "./firebaseKeys";
import { STORAGE_KEYS, getFromStorage, setToStorage } from "../constants";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BIuusKttSCIJA2vEUVJkCdCfWB-5f30uDO74ulhvhn89U4GqL5RKEyayPqMfk2L6OrKZRgkSelr-NKtt2sUrFiw",
        });

        if (fcm_token) {
          console.log({ fcm_token });
          await setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
